import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function CTSGuidePortal() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the first CTS page (Methodology)
    navigate("/main/cts-methodology", { replace: true });
  }, [navigate]);

  return null;
}
